/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RegexAtv2ExplanationEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('REGEX_ATV2_EXPLANATION_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class RegexAtv2ExplanationEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RegexAtv2ExplanationEnabledSettingParser.decode(input).map(res => new RegexAtv2ExplanationEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return RegexAtv2ExplanationEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RegexAtv2ExplanationEnabledSettingParser.encode(data);
    }
    static schema() {
        return RegexAtv2ExplanationEnabledSettingParser.schema();
    }
}
